import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
          <Typography
            sx={{ textTransform: 'uppercase', fontWeight: 700, letterSpacing: 1 }}
            variant="overline"
            color="primary"
            display="block"
            gutterBottom
          >
            TNO Academy presenta
          </Typography>
          <Box
            component={Typography}
            fontWeight={800}
            variant="h4"
            gutterBottom
            color={theme.palette.text.primary}
            sx={{ lineHeight: 1.2 }}
          >
            De la Idea al Stream: El Máster en Radio Visual
          </Box>
          <Typography
            variant="h6"
            component="p"
            color="textSecondary"
            sx={{ fontStyle: 'italic', mb: 2 }}
          >
            Domina el flujo de la comunicación moderna y haz que tu mensaje trascienda.
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            En <strong>TNO Media Lab</strong> no solo hacemos radio; lideramos <strong>The Content Evolution</strong>. Si tienes una idea, nosotros tenemos la ingeniería y el criterio periodístico para convertirla en un fenómeno multiplataforma.
          </Typography>
          <Box
            sx={{
              py: 1.5,
              px: 2,
              borderRadius: 2,
              borderLeft: 4,
              borderColor: 'primary.main',
              bgcolor: theme.palette.primary.main + '12',
            }}
          >
            <Typography variant="body1" fontWeight={600} color="primary">
              Este taller está diseñado para que dejes de ser un espectador y te conviertas en el <em>Arquitecto de tu propio Show</em>.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
          <Box
            sx={{
              width: '100%',
              maxWidth: 560,
              mx: { xs: 'auto', md: 0 },
              ml: { md: 'auto' },
            }}
          >
            <Box
              component="img"
              src="/images/Radio Presenter.png"
              alt="Radio presenter - TNO Academy, De la Idea al Stream"
              sx={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

Hero.propTypes = {
  themeMode: PropTypes.string,
};

export default Hero;
